import { ReactComponent as Palm } from "../rsc/palm.svg"
import { ReactComponent as Fruit } from "../rsc/fruit_pile.svg"
import { ReactComponent as Chevron } from "../rsc/chevron.svg"
import { ReactComponent as Truck } from "../rsc/truck_2.svg"
import { ReactComponent as Check } from "../rsc/circle_green_check.svg"
import "./CardChooseTransport.scss"
import { useTranslation } from "react-i18next"

type Props = {
    onClick?: () => void
}

export function CardChooseTransport({ onClick }: Props) {
    const { t } = useTranslation();
    return (
        <div onClick={onClick} className="bg-yellow-gradient boxShadow" style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "40px", gap: "25px" }}>
            <div>
                <Palm />
                <Fruit />
                <Fruit />
            </div>
            <div style={{ display: "flex", alignItems: "center", textAlign:"center" }}>
                <p className="text-extra-big" style={{ fontWeight: "700", margin: "0 20px 0 0" }}>{t('price_at_farm')}</p>
                <Chevron />
            </div>
            <div style={{ display: "flex", gap: "10px" }}>
                <div style={{ position: "relative" }}>
                    <Truck />
                    <Check style={{ position: "absolute", left: -16, top: -16, height: "32px", width: "32px" }} />
                </div>
                <p className="text-medium-plus" style={{ fontWeight: "700", maxWidth: "200px" }}>{t('transport_included')}</p>
            </div>
        </div>
    )
}